import React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

import Description from "../label/Description";
import Label from "../label/Label";
import { Checkbox } from "./Checkbox";

export interface CheckboxWithDescriptionProps {
  size: "base" | "sm";
  disabled?: boolean;
  label?: string;
  description?: string;
  onChange?: (e: boolean) => void;
  layoutClassName?: string;
  UNSAFE_className?: string;
  checked?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
  id?: string;
}

const CheckboxWithDescription: React.FC<CheckboxWithDescriptionProps> = ({
  size,
  disabled = false,
  label,
  description,
  onChange,
  checked = false,
  layoutClassName,
  UNSAFE_className,
  onKeyDown,
}) => {
  const onClick = () => {
    if (!disabled) {
      onChange?.(!checked);
    }
  };

  return (
    <div
      className={twMerge(
        "flex cursor-pointer items-start gap-2 font-normal",
        disabled && "cursor-not-allowed opacity-50",
        layoutClassName,
        UNSAFE_className,
      )}
      onClick={onClick}
    >
      <Checkbox
        checked={checked}
        disabled={disabled}
        onKeyDown={onKeyDown}
        onChange={onChange}
      />
      {(label || description) && (
        <div className="min-w-0 flex-1 gap-1">
          <Label
            UNSAFE_className={twMerge(
              size === "base" && "!leading-none",
              disabled && "cursor-not-allowed",
            )}
            label={label}
            size={size}
            breakWords
            pointer
          />
          <Description
            description={description}
            size={size}
            type="muted"
            breakWords
          />
        </div>
      )}
    </div>
  );
};

export { CheckboxWithDescription };
